const { getLegioNormsColor } = require('@/aquassist-shared/utils/helpers/normhelpers');


export default {
    computed: {
        color() {
            return (value, norm, options) => this.getColor(value, norm, options || {});
        },
    },
    methods: {
        getColor(value, norm, options = {}) {
            return this.setLimits(value, norm, options);
        },
        isDefined(value) {
            return value !== null && value !== undefined && value !== '';
        },
        setLimits(value, norm, options) {
            let lowestValue = null;
            let highestValue = null;
            // Getting the lowest value
            if (this.isDefined(norm?.veryLow)) {
                lowestValue = norm.veryLow;
            } else if (this.isDefined(norm?.low)) {
                lowestValue = norm.low;
            } else if (this.isDefined(norm?.minimum)) {
                lowestValue = norm.minimum;
            } else {
                lowestValue = null;
            }

            if (this.isDefined(norm?.veryHigh)) {
                highestValue = norm.veryHigh;
            } else if (this.isDefined(norm?.high)) {
                highestValue = norm.high;
            } else if (this.isDefined(norm?.maximum)) {
                highestValue = norm.maximum;
            } else {
                highestValue = null;
            }
            return this.changeColor(value, norm, lowestValue, highestValue, options);
        },
        changeColor(value, norm, lowestValue, highestValue, options = {}) {
            // Ensure options is defined and has the necessary properties, set defaults if not
            const { symbol = '' } = options || {};

            // Check if norm is null or undefined, return null to avoid further execution
            if (norm == null) return null;

            // If value is empty, return null
            if (!value) return null;

            // Check if values of norm object are empty or null
            const norms = { ...norm };
            delete norms.ref;
            if (Object.values(norms).every(x => x === null || x === '')) return null;
            let colorClass = 'normsGreen';

            // If no highest value and lowest value and norm does not belong to legio standard
            if (!norms.risk && !highestValue && !lowestValue) return null;
            let ret = false;
            // check for legionella norms
            if (norms.risk && norms.intervention) {
                return getLegioNormsColor({ value, symbole: symbol }, norms, null, false);
            }

            // Check for Simple stanadrd norms
            // we have first 3 norm level(VeryLow, Low, Minimum)
            if (!(this.isDefined(norm.veryHigh)) && !this.isDefined(norm.high) && !this.isDefined(norm.maximum)) {
                if (value < norm.minimum) {
                    colorClass = 'normsYellow';
                    ret = true;
                }

                if (value < norm.low && norm.low) {
                    colorClass = 'normsOrange';
                    ret = true;
                }

                if (value < norm.veryLow && norm.veryLow) {
                    colorClass = 'normsRed';
                    ret = true;
                }

                if (ret) return colorClass;
            }

            // we have  last 3 norm level(veryHigh, Maximum, high)
            if (!this.isDefined(norm.minimum) && !this.isDefined(norm.low) && !this.isDefined(norm.veryLow)) {
                if (value >= norm.maximum) {
                    colorClass = 'normsYellow';
                    ret = true;
                }
                if (value >= norm.high && norm.high) {
                    colorClass = 'normsOrange';
                    ret = true;
                }
                if (value >= norm.veryHigh && norm.veryHigh) {
                    colorClass = 'normsRed';
                    ret = true;
                }

                if (ret) {
                    return colorClass;
                }
            }

            // we have all 6 possible norm levels(simple standard)
            if (this.isDefined(norm.veryHigh) && this.isDefined(norm.veryLow) && this.isDefined(norm.minimum)) {
                if (value < norm.minimum) {
                    if (value < norm.minimum) {
                        colorClass = 'normsYellow';
                        ret = true;
                    }

                    if (value < norm.low && norm.low) {
                        colorClass = 'normsOrange';
                        ret = true;
                    }

                    if (value < norm.veryLow && norm.veryLow) {
                        colorClass = 'normsRed';
                        ret = true;
                    }

                    if (ret) {
                        return colorClass;
                    }
                }

                if (value >= norm.maximum) {
                    if (value >= norm.maximum) {
                        colorClass = 'normsYellow';
                        ret = true;
                    }

                    if (value >= norm.high && norm.high) {
                        colorClass = 'normsOrange';
                        ret = true;
                    }

                    if (value >= norm.veryHigh && norm.veryHigh) {
                        colorClass = 'normsRed';
                        ret = true;
                    }

                    if (ret) {
                        return colorClass;
                    }
                }
            }

            // we have 2 possible norm levels (Minimum & Maximum)
            if (!this.isDefined(norm.veryHigh) && !this.isDefined(norm.veryLow) && this.isDefined(norm.minimum) && this.isDefined(norm.maximum)) {
                if (value < lowestValue) {
                    colorClass = 'normsRed';
                    ret = true;
                }
                if (value >= lowestValue) {
                    colorClass = 'normsGreen';
                    ret = true;
                }
                if (value >= highestValue) {
                    colorClass = 'normsRed';
                    ret = true;
                }
            }

            return colorClass;
        },
        convertClassToColors(cssClass) {
            switch (cssClass) {
                case 'normsGreen':
                    return '#2A750F';
                case 'normsRed':
                    return '#AD1C3F';
                case 'normsYellow':
                    return '#D1A918';
                case 'normsOrange':
                    return '#FF9800';
                default:
                    return 'none';
            }
        },
    },
};
